export default {
  ADD_ITEM (state, item) {
    state.scenarios.unshift(item)
  },
  SET_SCENARIOS(state, scenarios) {
    state.scenarios = scenarios
  },
  UPDATE_SCENARIO(state, scenario) {
    const scenarioIndex = state.scenarios.findIndex((p) => p.id === scenario.id)
    Object.assign(state.scenarios[scenarioIndex], scenario)
  },
  REMOVE_ITEM (state, itemId) {
    const ItemIndex = state.scenarios.findIndex((p) => p.id === itemId)
    state.scenarios.splice(ItemIndex, 1)
  }
}
